<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MobileFooter',

  computed: {
    ...mapGetters({
      CONFIG: 'CONFIG',
      TOOLS: 'TOOLS'
    }),
    showLayerControl(){
      return this.TOOLS?.indexOf('layerControl') > -1
    }
  }
};
</script>

<template>
  <v-footer app color="primary">
    <v-btn v-if="showLayerControl" icon color="white" id="footer-layercontrol-btn">
      <v-icon>mdi-layers</v-icon>
    </v-btn>
  </v-footer>
</template>

<style scoped>

</style>
